import { ITestProps } from "../SingleTest"
import Diagram from "./Diagram"

/* Protopia Ecosystem component */ 
const DiagramResult = ({ item, ...props }: ITestProps): JSX.Element => {
    return <div className='pe-diagram-result-container'>
        <Diagram />
    </div>
}
export default DiagramResult